import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { getTotalsByDate } from 'redux/modules/journeys/selectors';

import DateTitle from './component';

const enhance = compose(
  injectIntl,
  connect((state, { date }) => {
    const totalsByDate = getTotalsByDate(state, date);
    return {
      numberOfItems: totalsByDate[date],
    };
  })
);

export default enhance(DateTitle);
